<template>
  <div class="popup-full  partner-registered-popup">
    <div class="popup-full__wrap">
      <button type="button"
              class="popup-full__close"
              @click="close">
        <BaseSvg name="ico-close"/>
      </button>

      <div class="popup-full__scroll">
        <div class="popup-full__content  partner-registered-popup__content">
          <div class="partner-registered-popup__title">
            {{ $tPartnersRegisteredPopup('title') }}
          </div>

          <div class="partner-registered-popup__main">
            <BasePreloader v-if="pending"/>

            <template v-if="receivedData">
              <div class="partner-registered-popup__main-inner-title">
                {{ $tPartnersRegisteredPopup('inner_title') }}
              </div>

              <div v-html="receivedData.html"
                   class="partner-registered-popup__copy-text  text">
                <p>Привет)</p>
                <p>Вот твоя ссылка <a href="https://jobian.com/log-in">https://jobian.com/log-in</a>, пароль и логин от
                  личного кабинета на сайт.</p>
                <p>
                  Логин: <span style="color: #001d3a">nefedofvladi</span><br>
                  Пароль: <span style="color: #001d3a">nefed-23</span>
                </p>
                <p>
                  В личном кабинете ты в дальнейшем сможешь удобно работать со всеми мигрантами. Сохрани пароль и логин
                  для дальнейшего входа в особстий кабинет.
                </p>
                <p>
                  Эту Jobian-ссылку <a href="https://jobian.com/username/referal-link/">https://jobian.com/username/referal-link/</a>
                  тебе нужно отправить мигранту, для которого актуальна работа за рубежом. Именно по этоой Jobian-ссылке
                  кандидат будет регистрироваться на сайте и подбирать работу.
                </p>
              </div>

              <div class="partner-registered-popup__footer">
                <button @click.prevent="copy"
                        class="partner-registered-popup__btn  _copy  base-btn  base-btn--green">
                  <BaseSvg name="ico-copy"
                           width="1.2rem"
                           height="1.2rem"/>
                  <span>{{ $tPartnersRegisteredPopup('copy_invite_btn') }}</span>

                  <span class="small-tooltip" :class="{'_show': showCopyTooltip}">
                    <BaseSvg name="ico-check"/>
                    <span>{{ $tPartnersRegisteredPopup('link_copied') }}</span>
                  </span>
                </button>
                <button @click.prevent="close"
                        class="partner-registered-popup__btn  base-btn  base-btn--outline-dark">
                  {{ $tPartnersRegisteredPopup('close_btn') }}
                </button>
              </div>
            </template>

            <BaseAlert :value="error"
                       class="partner-registered-popup__error  _warning"/>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {http} from '@/axios'
  import {blockScroll, unBlockScroll} from '@/helpers/scroll'
  import handleError from '@/helpers/handleError'

  let timerCopy

  export default {
    name: 'PartnersRegisteredPopup',
    props: {
      id: Number
    },
    data() {
      return {
        pending: false,
        error: null,

        showCopyTooltip: false,
        receivedData: null
      }
    },
    computed: {},
    methods: {
      close() {
        this.$emit('close')
      },
      copy() {
        navigator.clipboard.writeText(this.receivedData.non_html)
        this.showCopyTooltip = true

        clearTimeout(timerCopy)
        timerCopy = setTimeout(() => {
          this.showCopyTooltip = false
        }, 2000)
      },
      load() {
        this.pending = true

        http.get(`/api/cabinet/agent/get-message/${this.id}`)
          .then(({data}) => {
            this.receivedData = data.data
          })
          .catch(e => {
            this.error = handleError(e)
          })
          .finally(() => {
            this.pending = false
          })
      },
    },
    created() {
      blockScroll()

      this.load()
    },
    beforeDestroy() {
      unBlockScroll()
    }
  }
</script>
